<div class='container'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Import CSV Patients Tool</div>
    </div>

    <!-- Account email search + Find button -->
    <div class="mb-3">
        <label for="accountEmailSearch" class="form-label">Account email</label>
        <div class="d-flex">
            <input id="accountEmailSearch" class="form-control" type="text" [(ngModel)]="searchAccountEmailQuery"
                   placeholder="Enter email or fragment" [ngStyle]="accountSelected ? {'border-color':'#28a745','border-style':'solid','border-width':'1px'} : {}" />
            <button class="btn btn-primary ms-2" (click)="onFindAccounts()">Find</button>
            <button *ngIf="accountSelected" class="btn btn-danger ms-2" (click)="onClearSelectedAccount()">Clear</button>
        </div>
        <div class="form-text">Click Find to search accounts by email fragment; select one to confirm.</div>

        <!-- Tag name and tag color (optional) -->
        <div class="mt-3">
            <label for="tagName" class="form-label">Tag name (Optional)</label>
            <input id="tagName" class="form-control" type="text" [(ngModel)]="tagName" (ngModelChange)="onTagNameChange($event)" maxlength="20" placeholder="Enter tag name (optional)" />
            <div class="form-text text-end">{{ (tagName || '').length }} / 20</div>

            <label class="form-label mt-2">Tag color (Optional)</label>
            <div class="d-flex mt-1">
                <button *ngFor="let c of tagColorOptions" type="button" class="btn me-2" [disabled]="!tagName || tagName.trim() === ''"
                        [style.background]="c" [style.border]="tagColor === c ? '3px solid #000' : '1px solid #ccc'"
                        (click)="selectTagColor(c)" title="{{c}}" style="width:36px;height:36px;padding:0;">
                </button>
                <div *ngIf="tagColor" class="align-self-center ms-2">Selected: <span [style.background]="tagColor" style="display:inline-block;width:16px;height:16px;border:1px solid #ccc;margin-left:6px;margin-right:6px;"></span>{{ tagColor }}</div>
            </div>
        </div>

        <!-- Search results list -->
        <div *ngIf="searchResults && searchResults.length > 0" class="mt-2 list-group">
            <button type="button" class="list-group-item list-group-item-action" *ngFor="let account of searchResults"
                    (click)="onSelectAccount(account)">
                <strong>{{ account.email }}</strong>
                <div *ngIf="account.firstName || account.lastName">{{ account.firstName }} {{ account.lastName }}</div>
            </button>
        </div>

        <div *ngIf="accountSelected" class="mt-2 text-success">
            Selected: {{ selectedAccountEmail }}
        </div>
    </div>

    <div class="mb-3 text-center">
        <label class="form-label" style="font-size:1.25rem; font-weight:500; display:block;">Upload CSV file</label>
        <div class="d-flex justify-content-center align-items-center">
            <input type="file" accept=".csv,text/csv" (change)="onCsvFileSelected($event)" style="font-size:1.125rem;" />
        </div>
    </div>

    <div class="mb-3">
        <div class="mt-3">
            <label class="form-label" style="font-size:1.125rem;">Example CSV format</label>
            <pre style="background:#f8f9fa;padding:10px;border-radius:4px;border:1px solid #e9ecef;font-size:1.05rem;">First Name,Last Name,DOB,Email,Gender
John,Down,5/29/1995,johndown@gmail.com,Male</pre>
            <div class="form-text mb-3" style="font-size:1.5rem;">!Notes! </div>
            <div class="form-text" style="font-size:1.125rem;">1. Header values are case-sensitive and must match exactly.</div>
            <div class="form-text" style="font-size:1.125rem;">2. Email cell value can be empty, others cannot.</div>
            <div class="form-text" style="font-size:1.125rem;">3. DOB date format is m/d/YYYY.</div>
            <div class="form-text" style="font-size:1.125rem;">4. Erroneous CSV rows will be omitted.</div>

            <!-- Centered Bulk Import button: enabled only when an account is selected AND a CSV file is uploaded -->
            <div class="mt-4 text-center">
                <button class="btn btn-success btn-lg" (click)="onBulkImportPatients()" [disabled]="!accountSelected || !uploadedCsvFile">
                    Bulk Import patients
                </button>

                <!-- Result message shown after import (success or error) -->
                <div *ngIf="lastImportMessage" class="mt-3">
                    <div [ngClass]="{'text-success': lastImportSuccess === true, 'text-danger': lastImportSuccess === false}" style="font-size:1.125rem;">
                        {{ lastImportMessage }}
                    </div>

                    <!-- If import succeeded and server returned error notes (e.g., skipped rows), show them below in orange-red -->
                    <div *ngIf="lastImportSuccess === true && lastImportErrorNotes && lastImportErrorNotes.length > 0" class="mt-2">
                        <div *ngFor="let note of lastImportErrorNotes" style="color:#d9534f; font-weight:600;">
                            {{ note }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
